<template>
  <login-layout :title="layoutTit">
    <div
      v-if="page===1"
      class="login-merge"
    >
      <h3>{{ $t('message["337"]') }}</h3>
      <div class="merge-btn-box">
        <a-button
          type="primary"
          @click="mergeSet"
        >
          {{ $t('message["426"]') }}
        </a-button>
        <p>
          <router-link :to="{name: 'AccountInfo'}">
            {{ $t('message["896"]') }}
          </router-link>
        </p>
      </div>
    </div>
    <div
      v-else-if="page===2"
      class="login-merge"
    >
      <h3>{{ $t('message["1278"]') }}</h3>
      <div class="merge-tips mt-16">
        {{ $t('message["1406"]') }}。
      </div>
      <div class="merge-btn-box">
        <p>
          <router-link :to="{name: 'AccountInfo'}">
            {{ $t('message["282"]') }}
          </router-link>
        </p>
      </div>
    </div>
    <div
      v-else-if="page === 3"
      class="login-merge"
    >
      <h3>{{ $t('message["427"]') }} </h3>
      <div class="merge-tips mt-16">
        {{ mergeAccountTip[0] }}<br> {{ mergeAccountTip[1] }} <router-link :to="{name: 'AccountInfo'}">
          {{ $t('message["366"]') }}
        </router-link> {{ $t('message["117"]') }}。
      </div>
      <div class="merge-btn-box">
        <p>
          <router-link :to="{name: 'OrgIndex'}">
            {{ $t('message["439"]') }}
          </router-link>
        </p>
      </div>
    </div>
    <merge-form
      ref="mergeFormDia"
      :datas="formDatas"
      type="bind1"
    />
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
import MergeForm from '@/components/pc/account/MergeForm'
import { mapActions } from 'vuex'
import { setAuth, getAuth } from '@/lib/storage'
export default {
  name: 'Merge',
  components: {
    LoginLayout,
    MergeForm
  },
  data () {
    return {
      duration: 5,
      url: '',
      formDatas: {}
    }
  },
  computed: {
    datas () {
      const { query = {} } = this.$route
      const { param: paramStr = '' } = query
      if (paramStr) {
        const param = JSON.parse(decodeURIComponent(paramStr))
        const { payload = {} } = param
        return payload
      }
      return {}
    },
    page () {
      return this.$route.query.page * 1 || 1
    },
    layoutTit () {
      return this.$t('message["1381"]')
    },
    mergeAccountTip () {
      return this.$t('message["1570"]').split('|')
    }
  },
  mounted () {
    // this.$router.push({ name: 'Merge', query: { param: this.$route.query.param, page: 1 } })
    const { Authorization = '', fromurl = '/' } = this.datas
    if (Authorization) {
      setAuth(Authorization)
      this.$store.commit('setAuth', Authorization, { root: true })
    } else {
      this.$store.commit('setAuth', getAuth(), { root: true })
    }
    this.url = fromurl || '/'
  },
  methods: {
    ...mapActions('merge', ['mergeQw', 'mergeForm']),
    async mergeSet () {
      const chain = await this.mergeQw()
      chain.params({
        binduserid: this.datas.binduserid
      })
        .onNetSuccess((data) => {
          const res = data.data
          const error = res.error
          if (error === 104) {
            this.$router.push({ name: 'Merge', query: { param: this.$route.query.param, page: 2 } })
          } else if (error === 115) {
            this.formDatas = res.payload
            this.$refs.mergeFormDia.changeVisible(true)
          } else if (error === 0) {
            setAuth(res.payload.Authorization)
            this.$store.commit('setAuth', res.payload.Authorization, { root: true })
            this.$router.push({ name: 'Merge', query: { param: this.$route.query.param, page: 3 } })
          }
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .login-merge {
    // text-align: center;
    padding-top:0;
    width: 320px;
    padding-bottom: 120px;
    margin: 0 auto;
    text-align: center;

    h3 {
      font-weight: bold;
      line-height: 24px;
    }
    .merge-tips {
      line-height: 24px;
      color: #666;
    }

    .mt-16 {
      margin-top: 16px;
    }
    .merge-btn-box {
      .ant-btn-primary {
        width: 100%;
        margin-right: 0;
        margin-bottom: 24px;
      }
      width: 320px;
      margin-top: 48px;
    }

    p {
      line-height: 24px;
    }
  }
</style>
